module.exports = __webpack_public_path__ + "./img/SuperOferta.2b7de8a1670a5ee2b2610e7c77e52d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SuperOferta.png
// module id = ./src/assets/img/SuperOferta.png
// module chunks = 11